import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import LinkButton from '~/components/LinkButton/LinkButton.tsx';

type ISuccessModalProps = {
  isOpen: boolean;
  publicLink: string;
  onClose: () => void;
  onComplete: () => void;
};

export const SuccessManagerModal = ({
  isOpen,
  publicLink,
  onClose,
  onComplete,
}: ISuccessModalProps) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const onCopyClick = useCallback(async () => {
    if (isCopied) return;
    try {
      await navigator.clipboard.writeText(publicLink);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  }, [isCopied, publicLink]);

  useEffect(() => {
    if (!isOpen) {
      setIsCopied(false);
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent sx={{ py: 4 }}>
        <Box
          data-testid="success-manager-modal"
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <Typography
            data-testid="success-modal-title"
            variant="h6"
            component="h3"
            sx={{ fontWeight: 700 }}
          >
            Заява була створена та відправлена на вказану Вами пошту.
          </Typography>

          <Typography data-testid="success-modal-text" variant="body1">
            Наступне посилання можна використати для іншого каналу зв'язку:
          </Typography>

          <Box data-testid="link-button-wrapper" sx={{ display: 'flex', justifyContent: 'center' }}>
            <LinkButton
              linkUrl={publicLink}
              text="Копіювати"
              isCopied={isCopied}
              onCopyClick={onCopyClick}
            />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
            <Button variant="contained" onClick={onComplete} data-testid="submit-button">
              Готово
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
